import { User, Building2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EntityIconProps {
  type?: 'person' | 'organization' | 'other';
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export function EntityIcon({
  type = 'person',
  size = 'sm',
  className,
}: EntityIconProps) {
  const isOrg = type === 'organization';
  const Icon = isOrg ? Building2 : User;

  return (
    <div
      className={cn(
        'shrink-0 rounded-full flex items-center justify-center',
        size === 'xs' ? 'h-4 w-4' : size === 'sm' ? 'h-6 w-6' : 'h-8 w-8',
        isOrg
          ? 'bg-linear-to-br from-amber-50 to-orange-100/80 ring-1 ring-inset ring-amber-200/50'
          : 'bg-linear-to-br from-blue-50 to-indigo-100/80 ring-1 ring-inset ring-blue-200/50',
        className,
      )}
    >
      <Icon
        className={cn(
          size === 'xs' ? 'h-2.5 w-2.5' : size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5',
          isOrg ? 'text-amber-600' : 'text-blue-600',
        )}
        strokeWidth={2.25}
      />
    </div>
  );
}
